import React, { createContext, useState } from 'react';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('English'); 

  const toggleLanguage = () => {
    setLanguage(prevLanguage => prevLanguage === 'English' ? 'Deutsch' : 'English');
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};